<mdb-navbar SideClass="navbar navbar-expand-md navbar-dark mdb-color darken-3 ie-nav"
            [containerInside]="false">
  <links>
    <ul class="navbar-nav mr-auto">
    </ul>
    <span class="float-right">
         <ul class="navbar-nav mr-auto">

           <li class="nav-item waves-light" [routerLinkActive]="['active']">
              <a class="nav-link" mdbRippleRadius (click)="commonService.switchViewMode()">
  <img *ngIf="commonService.getViewMode()" class="userIcon"
       src="assets/images/switches/switch-on.svg"/>
  <img *ngIf="!commonService.getViewMode()" class="userIcon"
       src="assets/images/switches/switch-off.svg"/>
      </a>
            </li>
           <!-- Dropdown -->
            <li class="nav-item dropdown" dropdown>
               <a dropdownToggle type="button" class="nav-link dropdown-toggle waves-light" mdbRippleRadius>
                 <i class="fa fa-bars"></i>
               </a>
               <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary text-left dropdown-menu-right"
                    role="menu">
                 <a class="dropdown-item" mdbRippleRadius [routerLink]="['/']">
                       <i class="fa fa-smile"></i> Emotion Analysis
                 </a>
                  <a class="dropdown-item" mdbRippleRadius [routerLink]="['face-api']">
                    <i class="fa fa-smile-wink"></i> Face Analysis 2
                  </a>
                  <a class="dropdown-item" mdbRippleRadius [routerLink]="['object-detection']">
                    <i class="fa fa-video"></i> Object Detection
                  </a>
                  <a class="dropdown-item" mdbRippleRadius [routerLink]="['speech']">
                    <i class="fa fa-comment"></i> Speech Analysis
                  </a>
                 <a class="dropdown-item" mdbRippleRadius [routerLink]="['semantics']">
                      <i class="fa fa-link"></i> Semantic Analysis
                    </a>
                 <a class="dropdown-item" mdbRippleRadius [routerLink]="['speech-to-text']">
                      <i class="fa fa-comment-dots"></i> Speech to Text
                    </a>
                   <a class="dropdown-item" mdbRippleRadius [routerLink]="['about']">
                       <i class="fa fa-info"></i> About
                   </a>
                   <a class="dropdown-item" mdbRippleRadius [routerLink]="['help']">
                          <i class="fa fa-question"></i> Help
                   </a>
               </div>
            </li>
         </ul>
</span>
  </links>
</mdb-navbar>
